import React, { useEffect, useMemo, useState } from "react";
import { Box, Flex } from "rebass";
import { useDispatch, useSelector } from "react-redux";
import { MainLayout } from "../layouts/MainLayout";
import { UsersFilter } from "../components/client";
import { yodaCustomerActions } from "../logic/actions";
import { useParams } from "react-router-dom";
import config from "../utils/globalConfig";
import { LoadingFrame } from "../components/common/LoadingFrame";
import { getLocalizedString, history } from "../utils";
import useVirtualList from "../hooks/useVirtualList";
import { PreLoader } from "../components/loader/PreLoader";
import { resetScroll } from "../utils/resetScroll";
import MobileScrollCTA from "../components/MobileScrollCTA";
import useResponsive from "../hooks/useResponsive";
import { Redirect } from "react-router-dom/cjs/react-router-dom.min";
import Client from "../components/client/Client";

const UsersPage = () => {
  const dispatch = useDispatch();

  const { customers } = useSelector((state) => state.yodaCustomer);
  const { offsetTop } = useSelector((state) => state.system);
  const { me } = useSelector((state) => state.yodaStakeholders);
  const { scrolledToBottom } = useSelector((state) => state.layout);

  const [filteredUsers, setFilteredUsers] = useState(undefined);

  const { agentId } = useParams();
  const localstorageAgent = localStorage.getItem("selectedAgent");

  const { getVirtualItems, reset } = useVirtualList({ enableAutoScroll: true });
  const { isMobile } = useResponsive();

  const displayedUsers = useMemo(
    () => getVirtualItems(filteredUsers),
    [getVirtualItems, filteredUsers],
  );

  useEffect(() => {
    if (me?.role) {
      if (me.role === "Admins") {
        dispatch(yodaCustomerActions.getAll(agentId));
      }

      if (me.role === "Agents") {
        dispatch(yodaCustomerActions.getAll(agentId));
      }

      if (me.role === "CustomerCare") {
        dispatch(yodaCustomerActions.getAll(agentId));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [me]);

  useEffect(() => {
    if (agentId && me?.role === "Agents" && me?.id && agentId != me.id) {
      history.push("/homepage");
    }
  }, [agentId, me?.role, me?.id]);

  useEffect(() => {
    if (!localstorageAgent && me?.role === "CustomerCare") {
      localStorage.setItem("selectedAgent", agentId);
      window.location.reload();
    }
  }, [agentId, localstorageAgent, me?.role]);

  useEffect(() => {
    setFilteredUsers(customers);
  }, [customers]);

  const filterUsers = (query, status) => {
    reset();
    resetScroll();
    const selectedUsers = customers.filter(
      (customer) =>
        (query !== ""
          ? customer.checksum
              .toLowerCase()
              .match(new RegExp(".*" + query.toLowerCase() + ".*", "g")) !==
            null
          : true) &&
        (status !== "all" ? customer.channelDescription === status : true),
    );

    setFilteredUsers(selectedUsers);
  };

  if (
    me?.error === "not-authorized" ||
    (me?.role && me?.role !== "CustomerCare" && me?.role !== "Agents")
  ) {
    return (
      <Redirect
        to={{
          pathname: "/not-authorized",
          state: {
            yodaError: me?.error === "not-authorized",
            roleError:
              me?.role && me?.role !== "CustomerCare" && me?.role !== "Agents",
          },
        }}
      />
    );
  }
  return (
    <MainLayout client>
      <LoadingFrame customer={true}></LoadingFrame>
      <Flex width={1} flexDirection="column" pt={4} p={[1, null, 0]}>
        <Box
          sx={{
            position: "sticky",
            top: [offsetTop, 0],
            zIndex: 1,
            background: "white",
            width: "100%",
            maxWidth: config.VIEWPORT,
            paddingTop: ["20px", "30px"],
            paddingX: ["6px", "unset"],
            marginLeft: ["none", "auto"],
            marginRight: ["none", "auto"],
            marginBottom: ["15px", "unset"],
            paddingBottom: ["8px", "20px"],
          }}
        >
          <UsersFilter filterUsers={filterUsers} />
        </Box>
        <Box
          sx={{
            paddingX: ["6px", "unset", "unset"],
            width: "100%",
          }}
        >
          {!!displayedUsers?.length &&
            displayedUsers.map((client, index) => (
              <Client {...client} key={index.toString()} />
            ))}
          {!!displayedUsers?.length &&
            displayedUsers?.length < filteredUsers?.length &&
            scrolledToBottom && (
              <Flex
                justifyContent={"center"}
                alignContent={"center"}
                sx={{ width: "100%", py: "20px" }}
              >
                <PreLoader color="black" size="sm" />
              </Flex>
            )}
          {displayedUsers !== undefined && displayedUsers.length == 0 && (
            <Flex
              style={{
                height: "30px",
                display: "grid",
                justifyContent: "center",
                alignContent: "center",
              }}
              justifyContent={"center"}
              mb={4}
              fontSize={12}
            >
              {getLocalizedString("CUSTOMER IS EMPTY")}
            </Flex>
          )}
          {isMobile &&
            !!displayedUsers?.length &&
            displayedUsers?.length < filteredUsers?.length && (
              <MobileScrollCTA />
            )}
        </Box>
      </Flex>
    </MainLayout>
  );
};

export { UsersPage };
